const KEY = 'RS_COMPARE'
const saved = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]') } catch (_) { return [] } }
export default {
  namespaced: true,
  state: { items: saved(), limit: 4 },
  getters: { count: state => state.items.length, has: state => id => state.items.some(item => item.id === id) },
  mutations: {
    TOGGLE (state, product) {
      const index = state.items.findIndex(item => item.id === product.id)
      if (index >= 0) state.items.splice(index, 1)
      else if (state.items.length < state.limit) state.items.push(product)
      localStorage.setItem(KEY, JSON.stringify(state.items))
    },
    REMOVE (state, id) { state.items = state.items.filter(item => item.id !== id); localStorage.setItem(KEY, JSON.stringify(state.items)) },
    CLEAR (state) { state.items = []; localStorage.removeItem(KEY) }
  },
  actions: { toggle ({ commit }, product) { commit('TOGGLE', product) }, remove ({ commit }, id) { commit('REMOVE', id) } }
}
